import { Component, Input, OnInit } from '@angular/core';
import { FormField } from '../models/beans/form-field.abstract';

@Component({
  selector: 'textareafield[form]',
  templateUrl: './textareafield.component.html',
  styleUrls: ['./textareafield.component.scss']
})
export class TextareafieldComponent extends FormField {

  @Input() rows: number = 10;

}
